import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('forge-ui-overrides-property-in-extension-list');
	},
};
